// src/lib/labels-extra.ts
import type { components } from "@/api/schema";

type S = components["schemas"];

export const NOTIFICATION_TYPE: Record<S["NotificationType"], string> = {
  PAYMENT_REMINDER: "تذكير بدفعة مستحقة",
  LEAK_ALERT: "تنبيه تسرّب محتمل",
  MAINTENANCE_UPDATE: "تحديث على بلاغ صيانة",
  WAQF_DISTRIBUTION: "توزيع وقف",
  CONTRACT_EXPIRY: "اقتراب انتهاء عقد",
  OTP_CODE: "رمز تحقق",
  GENERAL: "تنبيه عام",
};
